const BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL;

export interface User {
  UserId: string;
  Email: string;
  Username: string;
  FirstName: string;
  LastName: string;
  AvatarObjPath: string | null;
  DateOfBirth: string;
  CreatedAt: string;
  UpdatedAt: string;
  IsActive: boolean;
  IsDeleted: boolean;
  Credits: number;
  Xp: number;
}

class UsersProvider {
  private async request<T>(path: string, options?: RequestInit): Promise<T> {
    const res = await fetch(`${BASE_URL}${path}`, {
      ...options,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });

    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
      throw new Error("Unauthorized");
    }

    if (!res.ok) {
      const text = await res.text().catch(() => "Unknown error");
      throw new Error(text || `HTTP ${res.status}`);
    }

    const text = await res.text();
    try {
      return JSON.parse(text) as T;
    } catch {
      return text as unknown as T;
    }
  }

  list(page: number = 1): Promise<User[]> {
    return this.request<User[]>(`/v1/users?page=${page}`);
  }

  search(q: string, page: number = 1): Promise<User[]> {
    return this.request<User[]>(`/v1/users/search?q=${encodeURIComponent(q)}&page=${page}`);
  }

  getById(userId: string): Promise<User> {
    return this.request<User>(`/v1/users/${encodeURIComponent(userId)}`);
  }

  getBlocks(userId: string): Promise<string[]> {
    return this.request<string[]>(`/v1/admin/users/${encodeURIComponent(userId)}/blocks`);
  }
}

export const usersProvider = new UsersProvider();
